import { Injectable } from "@angular/core";
import { AdvancedReportService, Status, translateCommonErrorStatus } from "@core/data";
import { AdvancedReport } from "@core/data/types/advanced-report";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";

export interface AdvancedReportFormStateModel {
    key: string;
    ownerOrgKey: string;
    status: Status;
    data: Partial<AdvancedReport>;
}

const DEFAULTS: AdvancedReportFormStateModel = {
    key: null,
    ownerOrgKey: null,
    status: Status.UNINITIALIZED,
    data: null,
}

export class InitNewReportForm {
    static readonly type = "[AdvancedReportForm] Init new";
    constructor(public key: string, public defaults?: Partial<AdvancedReport>) { }
}

export class SubmitReportForm {
    static readonly type = "[AdvancedReportForm] Submit";
    constructor(public report: Partial<AdvancedReport>) { }
}

@State<AdvancedReportFormStateModel>({
    name: 'advanced_report_form',
    defaults: DEFAULTS
})
@Injectable()
export class AdvancedReportFormState {

    @Selector()
    static data(state: AdvancedReportFormStateModel) {
        return state.data;
    }

    constructor(
        private _reportService: AdvancedReportService,
    ) {}

    @Action(InitNewReportForm)
    initNewReportForm(ctx: StateContext<AdvancedReportFormStateModel>, action: InitNewReportForm) {


        ctx.setState({
            ...DEFAULTS,
            ownerOrgKey: action?.defaults?.ownerOrgKey || null,
            key: action.key,
            data: {
                ...action.defaults
            },
            status: Status.OK,
        });
    }

    @Action(SubmitReportForm)
    submitReportForm(ctx: StateContext<AdvancedReportFormStateModel>, action: SubmitReportForm) {
        const state = ctx.getState();

        ctx.patchState({
            status: Status.LOADING,
        });

        return this._reportService.update(state.key, action.report)
            .pipe(
                tap(
                    result => {
                        ctx.patchState({
                            key: result.key,
                            status: Status.COMPLETE,
                            data: result,
                        })
                    },
                    error => {
                        ctx.patchState({
                            status: translateCommonErrorStatus(error)
                        });
                    }
                )
            )
    }
}